// react components

// react-router-dom components

// mui components
import Paper from "@mui/material/Paper";

// mui-icons components

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

//routes

//assets

function SideNavLayout({ children = <></>, title = "Filters" }) {
    return (
        <Paper
            style={{
                minWidth: "270px",
                maxWidth: "270px",
                background: "#fff",
            }}
        >
            <div
                style={{
                    padding: "10px",
                    // maxHeight: `calc(100vh - ${height}px)`,
                    // minHeight: `calc(100vh - ${height}px)`,
                    // overflowY: "scroll",
                }}
            >
                <p
                    style={{
                        fontSize: "0.75rem",
                        marginBottom: "10px",
                    }}
                >
                    {title}
                </p>
                <hr />
                {children}
            </div>
        </Paper>
    );
}

// Typechecking props for the SideNavLayout
SideNavLayout.propTypes = {
    children: PropTypes.object,
    title: PropTypes.string,
};

export default SideNavLayout;
